import { useHandler } from "@suse-o11y/use-handler";
import { useEffect } from "react";

import type { Monaco } from "../_monaco";

export function useOnEditorBlur(editor: null | Monaco.editor.IStandaloneCodeEditor, onBlur: VoidFunction): void {
	const onBlurStable = useHandler(onBlur);

	useEffect(() => {
		const disposable = editor?.onDidBlurEditorText(onBlurStable);

		return () => {
			disposable?.dispose();
		};
	}, [editor, onBlurStable]);
}
